import templateUrl from "emun.vendor/vendor-shopify-credentials.htm";
import VendorShopifyCredentialsController from "emun.vendor/vendor-shopify-credentials.controller";
import open from "webmodals/open";

let VendorShopifyCredentials = options => {
  let modalInstance = open({
    size: options.size || "md",
    templateUrl: options.templateUrl || templateUrl,
	  controller: VendorShopifyCredentialsController,
    bindToController: true,
    controllerAs: "$ctrl",
    resolve: {
      options: () => options
    }
  });

  return modalInstance.result;
};

export default VendorShopifyCredentials;
